import React, {Dispatch, SetStateAction} from "react";

interface Props {
    loading?: boolean;
    pageLimit: number;
    start: number;
    end: number;
    currentPage?: number;
    totalElements?: number;
    setIndex?: Dispatch<SetStateAction<number | undefined>>;
}

export default function ButtonsPagination({
                                              loading,
                                              pageLimit,
                                              end,
                                              start,
                                              currentPage,
                                              totalElements,
                                              setIndex
                                          }: Props) {
    return (
        <div className="flex items-center gap-2">
            {[...Array(pageLimit)].map((page, i) => {
                if (i >= start && i < end) {
                    return (
                        <div
                            key={i}
                            className={`cursor-pointer ${loading || !totalElements ? 'pointer-events-none' : ''} w-[21.59px] h-[26px] 
                            bg-white rounded-[5px] flex flex-row place-content-center items-center 
                            ${currentPage === i ? '!border-[2px]' : '!border-[1px]'} border-gray-400`}
                            onClick={() => {
                            if (setIndex) setIndex(i)
                        }}><span
                            className={`text-gray-500`}>{i + 1}</span></div>
                    );
                }
            })}
        </div>
    )
}